import * as api from '../../../clients/veranstaltungen';

import {Action} from '@ngrx/store';

export const POST_FUNKPROTOKOLL_VORLAGE_ENTFERNEN_ADMIN = '[VeranstaltungenModul] PostFunkprotokollVorlageEntfernenAdmin laden';
export const POST_FUNKPROTOKOLL_VORLAGE_ENTFERNEN_ADMIN_AUSFUEHREN = '[VeranstaltungenModul] PostFunkprotokollVorlageEntfernenAdmin ausführen';
export const POST_FUNKPROTOKOLL_VORLAGE_ENTFERNEN_ADMIN_ERFOLGREICH = '[VeranstaltungenModul] PostFunkprotokollVorlageEntfernenAdmin laden erfolgreich';
export const POST_FUNKPROTOKOLL_VORLAGE_ENTFERNEN_ADMIN_FEHLER = '[VeranstaltungenModul] PostFunkprotokollVorlageEntfernenAdmin Ladefehler';
export const POST_FUNKPROTOKOLL_VORLAGE_ENTFERNEN_ADMIN_NICHT_AUSGEFUEHRT = '[VeranstaltungenModul] PostFunkprotokollVorlageEntfernenAdmin nicht ausgeführt (evtl. Offline)';


export class PostFunkprotokollVorlageEntfernenAdminAction implements Action {
    readonly type = POST_FUNKPROTOKOLL_VORLAGE_ENTFERNEN_ADMIN;
        constructor(public funkprotokollVorlageRequest: api.FunkprotokollVorlageRequest, public optPayload: any = null) {}
    }
export class PostFunkprotokollVorlageEntfernenAdminAusfuehrenAction implements Action {
    readonly type = POST_FUNKPROTOKOLL_VORLAGE_ENTFERNEN_ADMIN_AUSFUEHREN;
        constructor(public funkprotokollVorlageRequest: api.FunkprotokollVorlageRequest, public optPayload: any = null) {}
    }
export class PostFunkprotokollVorlageEntfernenAdminErfolgreichAction implements Action {
    readonly type = POST_FUNKPROTOKOLL_VORLAGE_ENTFERNEN_ADMIN_ERFOLGREICH;
        constructor(public payload: api.FunkprotokollVorlageIdentifier, public funkprotokollVorlageRequest: api.FunkprotokollVorlageRequest, public optPayload: any = null) {}
    }
export class PostFunkprotokollVorlageEntfernenAdminFehlerAction implements Action {
    readonly type = POST_FUNKPROTOKOLL_VORLAGE_ENTFERNEN_ADMIN_FEHLER;
        constructor(public payload: any, public funkprotokollVorlageRequest: api.FunkprotokollVorlageRequest, public optPayload: any = null) {}
    }
export class PostFunkprotokollVorlageEntfernenAdminNichtAusgefuehrtAction implements Action {
    readonly type = POST_FUNKPROTOKOLL_VORLAGE_ENTFERNEN_ADMIN_NICHT_AUSGEFUEHRT;
        constructor(public optPayload: any = null) {}
    }
    

export type VeranstaltungenCommandFunkprotokollVorlageEntfernenAdminActions =
    PostFunkprotokollVorlageEntfernenAdminAction
    | PostFunkprotokollVorlageEntfernenAdminAusfuehrenAction
    | PostFunkprotokollVorlageEntfernenAdminErfolgreichAction
    | PostFunkprotokollVorlageEntfernenAdminFehlerAction
    | PostFunkprotokollVorlageEntfernenAdminNichtAusgefuehrtAction
    ;
